export default
    {
        // 医护人员订单列表
        async getDoctorOrderList(params) {
            let actiontype = 'nurseOrderList';
            return await this.fetch(actiontype, params);
        },
        // 提交订单
        async submitDoctorOrder(params) {
            let actiontype = 'applyNurseOrder';
            return await this.fetch(actiontype, params);
        },
        // 申请改期  
        async changeDoctorDate(params) {
            let actiontype = 'nurseOrderChange';
            return await this.fetch(actiontype, params);
        },
        // 订单详情 
        async getDoctorOrderDetail(params) {
            let actiontype = 'nurseOrderDetail';
            return await this.fetch(actiontype, params);
        },
        // 退票申请 
        async refundDoctorOrder(params) {
            let actiontype = 'nurseOrderRefund';
            return await this.fetch(actiontype, params);
        },
    }


// WEBPACK FOOTER //
// ./src/interfaces/modules/doctor.js